// MACHINE DRAFT — language/clinical review required before activation.
export default {
  "ar": [
    "أسئلة عن التحضير لزيارتي",
    "اختر أي أسئلة تود مناقشتها مع فريق المستشفى الذي يتولى رعايتك.",
    "اختر هذا السؤال",
    "احفظ الأسئلة المحددة في «رعايتي»",
    "اطبع الأسئلة المحددة",
    "محفوظ بالفعل في «رعايتي»",
    "تم حفظ الأسئلة المحددة في «رعايتي» على هذا الجهاز.",
    "اختر سؤالًا واحدًا أو أكثر لحفظه أو طباعته.",
    "الأسئلة التي أريد طرحها",
    "هذه هي أسئلة التحضير التي اخترتها. يمكنك حفظها في «رعايتي» أو طباعتها لأخذها معك إلى موعدك.",
    "افتح «رعايتي»",
    "الطباعة لا ترسل أسئلتك إلى المستشفى.",
    "هذه الأسئلة لا تحل محل تعليمات المستشفى. فيما يتعلق بالأدوية والامتناع عن الطعام والشراب وترتيبات الخروج من المستشفى، اتبع الإرشادات الفردية التي يقدمها فريق المستشفى المسؤول عن رعايتك.",
    "متى يجب أن أتوقف عن الأكل والشرب قبل عمليتي الجراحية؟",
    "أي من أدويتي المعتادة ينبغي أن أتناوله أو أغيّره قبل العملية الجراحية؟",
    "إلى أين يجب أن أذهب، وفي أي وقت ينبغي أن أصل؟",
    "إلى أين ينبغي أن أذهب، ومتى يجب أن أصل لدخولي المستشفى؟",
    "هل أحتاج إلى ترتيب وسيلة نقل إلى المستشفى، أم ينبغي أن أسأل عما إذا كنت مؤهلًا لخدمة نقل المرضى؟",
    "هل سأحتاج إلى شخص يعيدني إلى المنزل أو يبقى معي بعد الجراحة؟",
    "ما المساعدة التي قد أحتاج إليها عند مغادرة المستشفى، ومع من ينبغي أن أناقش ذلك؟",
    "بمن ينبغي أن أتصل إذا كانت لدي مخاوف بعد عودتي إلى المنزل؟"
  ],
  "bn": [
    "আমার প্রস্তুতি নিয়ে প্রশ্ন",
    "আপনার হাসপাতালের সেবাদানকারী দলের সঙ্গে যে বিষয়গুলো আলোচনা করতে চান, সেগুলো বেছে নিন।",
    "এই প্রশ্নটি বেছে নিন",
    "নির্বাচিত প্রশ্নগুলো ‘আমার যত্ন’-এ সংরক্ষণ করুন",
    "নির্বাচিত প্রশ্নগুলো প্রিন্ট করুন",
    "ইতিমধ্যেই ‘আমার যত্ন’-এ আছে",
    "নির্বাচিত প্রশ্নগুলো এই ডিভাইসে ‘আমার যত্ন’-এ সংরক্ষিত হয়েছে।",
    "সংরক্ষণ বা প্রিন্ট করার জন্য এক বা একাধিক প্রশ্ন বেছে নিন।",
    "আমি যে প্রশ্নগুলো করতে চাই",
    "আপনি প্রস্তুতি নিয়ে এই প্রশ্নগুলো বেছে নিয়েছেন। অ্যাপয়েন্টমেন্টে নিয়ে যাওয়ার জন্য এগুলো ‘আমার যত্ন’-এ সংরক্ষণ করতে বা প্রিন্ট করতে পারেন।",
    "‘আমার যত্ন’ খুলুন",
    "প্রিন্ট করলে আপনার প্রশ্নগুলো হাসপাতালে পাঠানো হয় না।",
    "এই প্রশ্নগুলো আপনার হাসপাতালের নির্দেশনার বিকল্প নয়। ওষুধ, অপারেশনের আগে খাওয়াদাওয়া বন্ধ রাখা এবং হাসপাতাল থেকে ছাড়পত্রের ব্যবস্থা সম্পর্কে আপনার হাসপাতালের সেবাদানকারী দলের দেওয়া ব্যক্তিগত নির্দেশনা মেনে চলুন।",
    "আমার অপারেশনের আগে কখন থেকে খাওয়া ও পান করা বন্ধ করতে হবে?",
    "অপারেশনের আগে আমার নিয়মিত ওষুধগুলোর মধ্যে কোনগুলো খেতে হবে বা বদলাতে হবে?",
    "আমাকে কোথায় যেতে হবে এবং কখন পৌঁছাতে হবে?",
    "হাসপাতালে ভর্তি হতে আমাকে কোথায় যেতে হবে এবং কখন পৌঁছাতে হবে?",
    "হাসপাতালে যাওয়ার জন্য কি আমাকে যাতায়াতের ব্যবস্থা করতে হবে, নাকি রোগী পরিবহন পরিষেবা পাওয়ার যোগ্য কি না তা জিজ্ঞেস করব?",
    "অপারেশনের পরে আমাকে বাড়ি নিয়ে যাওয়ার বা আমার সঙ্গে থাকার জন্য কি কাউকে লাগবে?",
    "হাসপাতাল থেকে বাড়ি যাওয়ার সময় আমার কী ধরনের সাহায্য লাগতে পারে এবং এ বিষয়ে কার সঙ্গে কথা বলব?",
    "বাড়ি ফেরার পরে কোনো উদ্বেগ থাকলে কার সঙ্গে যোগাযোগ করব?"
  ],
  "es": [
    "Preguntas sobre mi preparación",
    "Seleccione las cuestiones que quiera comentar con el equipo de su hospital.",
    "Seleccionar esta pregunta",
    "Guardar las preguntas seleccionadas en Mis cuidados",
    "Imprimir las preguntas seleccionadas",
    "Ya está guardado en Mis cuidados",
    "Las preguntas seleccionadas se han guardado en Mis cuidados en este dispositivo.",
    "Seleccione una o varias preguntas para guardarlas o imprimirlas.",
    "Preguntas que quiero hacer",
    "Estas son las preguntas de preparación que ha seleccionado. Puede guardarlas en Mis cuidados o imprimirlas para llevarlas a su cita.",
    "Abrir Mis cuidados",
    "Al imprimir las preguntas, estas no se envían al hospital.",
    "Estas preguntas no sustituyen las instrucciones de su hospital. En relación con los medicamentos, el ayuno y los preparativos para el alta, siga las indicaciones individuales que le dé el equipo de su hospital.",
    "¿Cuándo debo dejar de comer y beber antes de mi operación?",
    "¿Cuáles de mis medicamentos habituales debo tomar o modificar antes de mi operación?",
    "¿Adónde tengo que ir y a qué hora debo llegar?",
    "¿Adónde debo dirigirme y a qué hora tengo que llegar para mi ingreso?",
    "¿Tengo que organizar el transporte al hospital o preguntar si reúno los requisitos para el transporte de pacientes?",
    "¿Necesitaré que alguien me lleve a casa o se quede conmigo después de la operación?",
    "¿Qué ayuda podría necesitar al salir del hospital y con quién debo hablarlo?",
    "¿Con quién debo ponerme en contacto si tengo alguna preocupación después de volver a casa?"
  ],
  "fa": [
    "پرسش‌هایی دربارهٔ آمادگی من",
    "هر پرسشی را که می‌خواهید با تیم درمانی بیمارستان خود مطرح کنید انتخاب کنید.",
    "این پرسش را انتخاب کنید",
    "ذخیرهٔ پرسش‌های انتخاب‌شده در «مراقبت من»",
    "چاپ پرسش‌های انتخاب‌شده",
    "قبلاً در «مراقبت من» ذخیره شده است",
    "پرسش‌های انتخاب‌شده در «مراقبت من» روی این دستگاه ذخیره شدند.",
    "برای ذخیره یا چاپ، یک یا چند پرسش انتخاب کنید.",
    "پرسش‌هایی که می‌خواهم بپرسم",
    "این‌ها پرسش‌هایی هستند که دربارهٔ آمادگی انتخاب کرده‌اید. می‌توانید آن‌ها را در «مراقبت من» ذخیره کنید یا برای قرار ملاقاتتان چاپ کنید.",
    "باز کردن «مراقبت من»",
    "چاپ پرسش‌ها باعث ارسال آن‌ها به بیمارستان نمی‌شود.",
    "این پرسش‌ها جایگزین دستورهای بیمارستان شما نیستند. دربارهٔ داروها، ناشتا بودن و برنامهٔ ترخیص، راهنمایی شخصی تیم درمان بیمارستان خود را دنبال کنید.",
    "پیش از عمل جراحی، از چه زمانی باید خوردن و آشامیدن را متوقف کنم؟",
    "پیش از عمل جراحی، کدام داروهای همیشگی‌ام را باید مصرف کنم یا تغییر دهم؟",
    "کجا باید بروم و چه ساعتی باید برسم؟",
    "برای بستری شدن کجا باید بروم و چه زمانی باید برسم؟",
    "آیا باید رفت‌وآمد به بیمارستان را خودم هماهنگ کنم یا دربارهٔ واجد شرایط بودن برای سرویس حمل‌ونقل بیمار سؤال کنم؟",
    "آیا پس از جراحی به کسی نیاز دارم که مرا به خانه ببرد یا کنارم بماند؟",
    "هنگام ترخیص از بیمارستان ممکن است به چه کمکی نیاز داشته باشم و با چه کسی باید در این باره صحبت کنم؟",
    "اگر پس از بازگشت به خانه نگرانی داشتم، باید با چه کسی تماس بگیرم؟"
  ]
};
